import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import WhyBookSection from "./components/WhyBookSection";
import TeamSection from "./components/TeamSection";
import LocationsSection from "./components/LocationsSection";
import CorporateSection from "./components/CorporateSection";
import BridalSection from "./components/BridalSection";
import LoyaltySection from "./components/LoyaltySection";
import TestimonialsSection from "./components/TestimonialsSection";
import InsuranceSection from "./components/InsuranceSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";
import AdminLogin from "./components/AdminLogin";
import ClientPortal from "./components/ClientPortal";
import BookingConfirmed from "./components/BookingConfirmed";
import GiftVoucherSection from "./components/GiftVoucherSection";
import VoucherConfirmed from "./components/VoucherConfirmed";
import GoogleReviewsSection from "./components/GoogleReviewsSection";
import TreatHerPromo from "./components/TreatHerPromo";
import ThursdayDeal from "./components/ThursdayDeal";
import GallerySection from "./components/GallerySection";
import WellnessClubSection from "./components/WellnessClubSection";
import MeetRinoPromo from "./components/MeetRinoPromo";
import PackagesSection from "./components/PackagesSection";
import InstagramSection from "./components/InstagramSection";
import PopularServicesSection from "./components/PopularServicesSection";
import MastersAthleticsPromo from "./components/MastersAthleticsPromo";
import SportsRecoverySpotlight from "./components/SportsRecoverySpotlight";
import DublinMarathonPromo from "./components/DublinMarathonPromo";
import LunchtimeDeal from "./components/LunchtimeDeal";
import VacancySection from "./components/VacancySection";
import PackageConfirmed from "./components/PackageConfirmed";
import CouplesPage from "./components/CouplesPage";
import SeasonalVoucherBanner from "./components/SeasonalVoucherBanner";
import SignatureMassages from "./components/SignatureMassages";
import DealsStrip from "./components/DealsStrip";
import OfferPage from "./components/OfferPage";
import SportsRecoveryPage from "./components/SportsRecoveryPage";
import BlogPage from "./components/BlogPage";
import BlogPostPage from "./components/BlogPostPage";
import NotFoundPage from "./components/NotFoundPage";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <SeasonalVoucherBanner />
      <main>
        <HeroSection />
        <DealsStrip />
        <PopularServicesSection />
        <SignatureMassages />
        <ServicesSection />
        <TeamSection />
        <MeetRinoPromo />
        <DublinMarathonPromo />
        <MastersAthleticsPromo />
        <SportsRecoverySpotlight />
        <LunchtimeDeal />
        <TreatHerPromo />
        <ThursdayDeal />
        <WhyBookSection />
        <PackagesSection />
        <WellnessClubSection />
        <GiftVoucherSection />
        <GallerySection />
        <LocationsSection />
        <GoogleReviewsSection />
        <InstagramSection />
        <CorporateSection />
        <BridalSection />
        <LoyaltySection />
        <TestimonialsSection />
        <InsuranceSection />
        <VacancySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

const AdminPage = () => {
  const navigate = useNavigate();
  return <AdminLogin onBack={() => navigate('/')} DashboardComponent={AdminDashboard} />;
};

const ClientPage = () => {
  const navigate = useNavigate();
  return <ClientPortal onBack={() => navigate('/')} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/my-bookings" element={<ClientPage />} />
          <Route path="/booking-confirmed" element={<BookingConfirmed />} />
          <Route path="/voucher-confirmed" element={<VoucherConfirmed />} />
          <Route path="/package-confirmed" element={<PackageConfirmed />} />
          <Route path="/couples" element={<CouplesPage />} />
          <Route path="/offer" element={<OfferPage />} />
          <Route path="/sports-recovery" element={<SportsRecoveryPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
